module.exports = __webpack_public_path__ + "img/avatar5.62706b5.svg";